"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var abTranslate_runtime_1 = tslib_1.__importDefault(require("ab-translate/dist/src/abTranslate-runtime"));
var lodash_1 = require("lodash");
var allTranslations = (0, lodash_1.get)(global, '__Locale.translations', {});
var experiments = (0, lodash_1.get)(global, '__EXPERIMENTS__', null);
var translations = (0, abTranslate_runtime_1.default)(experiments, allTranslations);
exports.default = {
    getAll: function () { return translations; },
    get: function (id) { return (0, lodash_1.get)(translations, [id]); },
    set: function (messages) {
        allTranslations = messages;
        translations = (0, abTranslate_runtime_1.default)(experiments, allTranslations);
    },
    setExperiments: function (specs) {
        experiments = specs;
        translations = (0, abTranslate_runtime_1.default)(experiments, allTranslations);
    },
};
//# sourceMappingURL=translations.js.map